module.exports = __webpack_public_path__ + "img/NITHIYA-SAFETY.29c46701.jpg";